/**
 * All panel related configuration constants.
 */
module.exports = {
    CLASS: {
        CLOSE: 'hom-panel-close',
        OPEN: 'hom-panel-open',
        OPENED: 'hom-panel__opened',
        PANEL: 'hom-panel'
    },
    ATTRIBUTES: {
        DATA_TARGET: 'data-panel-target'
    },
    EVENTS: {
        OPEN: 'hompanel:open',
        CLOSE: 'hompanel:close'
    }
};
